import { Bot, EditableBotVersionSlice } from '@/domain/bot';

export const botVersionsAreDifferent = (bot1: Bot, bot2: Bot) => {
    if (bot1.name != bot2.name) {
        // console.log('Different name');
        return true;
    }
    if (bot1.description != bot2.description) {
        // console.log('Different desc');
        return true;
    }
    if (bot1.language != bot2.language) {
        // console.log('Different lang');
        return true;
    }
    if (bot1.voiceConfig?.ttsVoice?.voice != bot2.voiceConfig?.ttsVoice.voice) {
        // console.log('Different voice');
        return true;
    }
    if (bot1.nodesReactFlow.length != bot2.nodesReactFlow.length) {
        // console.log('Different node count');
        return true;
    }
    for (let i = 0; i < bot1.nodesReactFlow.length; i += 1) {
        const node1 = bot1.nodesReactFlow[i];
        const node2 = bot2.nodesReactFlow[i];

        if (JSON.stringify(node1.data) != JSON.stringify(node2.data)) {
            // console.log('Different node data');
            return true;
        }

        if (JSON.stringify(node1.position) != JSON.stringify(node2.position)) {
            // console.log('Different node position');
            return true;
        }
    }
    if (bot1.taskValues?.length != bot2.taskValues?.length) {
        // console.log('Different task value count');
        return true;
    }
    for (let i = 0; i < (bot1.taskValues?.length || 0); i += 1) {
        if (bot1.taskValues[i].value != bot2.taskValues[i].value) {
            // console.log('Different names');
            return true;
        }
        if (
            bot1.taskValues[i].variableName != bot2.taskValues[i].variableName
        ) {
            // console.log('Different variable name');
            return true;
        }
    }
    return false;
};

export const pushUndoAction = (
    state: EditableBotVersionSlice,
    get: () => EditableBotVersionSlice,
) => {
    if (new Date().getTime() - get().lastTimeUndoOrRedo < 100) {
        // is part of undo/redo action, ignore
        return;
    }

    if (
        state.itemsUndo.length > 0 &&
        !botVersionsAreDifferent(
            state.itemsUndo[state.itemsUndo.length - 1],
            get().editingBot,
        )
    ) {
        return;
    }
    // if (new Date().getTime() - get().lastTimeChangedUndoStack < 100) {
    //     // skip save to undo chain when last save was recently
    //     return;
    // }

    state.itemsUndo.push(get().editingBot);
    state.itemsRedo = [];
    // state.lastTimeChangedUndoStack = new Date().getTime();
};

export const resetUndoStack = (
    state: EditableBotVersionSlice,
    get: () => EditableBotVersionSlice,
) => {
    state.itemsUndo = [get().editingBot];
    state.itemsRedo = [];
    // state.lastTimeChangedUndoStack = new Date().getTime();
    state.lastTimeUndoOrRedo = 0;
};

export const isProgrammaticBot = (labels?: { name: string }[]) => {
    return labels?.some((label) => label.name === 'programmatic') ?? false;
};

/** `custom-cxd` label → DFE editor. */
export const isCustomCxdBot = (
    labels?: ReadonlyArray<{ name: string } | null | undefined> | null,
): boolean => {
    return labels?.some((label) => label?.name === 'custom-cxd') ?? false;
};
